<template>
  <div id="app">
    <v-app>
      <TopNavi></TopNavi>
      <Notify />
      <router-view />
    </v-app>
  </div>
</template>

<script>
import TopNavi from "./components/Navigation/TopNavi";
import Notify from "./components/Notifications/Notify";

export default {
  components: { 
    TopNavi, 
    Notify 
  },
  data: () => ({
    sidebar: false,
    appTitle: "Robin Data "
  })
};
</script>
